import { ReactNode } from 'react';
import dayjs from 'dayjs';
import esES from 'antd/es/locale/es_ES';
import enUS from 'antd/es/locale/en_US';

import {
    Col,
    Row,
    ConfigProvider,
    Input,
    DatePicker,
} from 'antd';
import { BsHash } from 'react-icons/bs';
import { useTranslation } from 'react-i18next';

interface Props {
    loading: boolean;
    search?: string;
    handleSearch?: (e: any) => void;
    numericId?: string;
    handleNumericId?: (e: any) => void;
    startDate?: string;
    endDate?: string;
    handleDate?: (e: any) => void;
    refreshData: () => void;
    extra?: ReactNode;
}

const { RangePicker }: any = DatePicker;

const Filters = ({
    loading,
    search,
    handleSearch,
    numericId,
    handleNumericId,
    startDate,
    endDate,
    handleDate,
    refreshData,
    extra,
}: Props) => {
    const { t, i18n } = useTranslation('bookings', { keyPrefix: 'FILTERS' });

    return (
        <Row className="home__filters" gutter={[16, 16]} justify="start" align="top">
            {/* <Col className="home__filters--col-search">
                <Input
                    style={{ width: 300 }}
                    size="small"
                    allowClear
                    className="home__input--search"
                    placeholder={t('SEARCH')}
                    prefix={<BsSearch className="home__input-icon" />}
                    onChange={handleSearch}
                    value={search}
                    disabled={loading}
                />
            </Col> */}
            <Col className="home__filters--col-numeric">
                <ConfigProvider locale={i18n.language === 'en' ? enUS : esES}>
                    <RangePicker
                        value={startDate ? [dayjs(startDate), dayjs(endDate)] : null}
                        onChange={(date: any = []) => {
                            if (handleDate) {
                                if (date) {
                                    const [start, end] = date;
                                    handleDate([
                                        start.startOf('day').toISOString(),
                                        end.endOf('day').toISOString(),
                                    ]);
                                } else {
                                    handleDate(['', '']);
                                }
                            }
                        }}
                    />

                </ConfigProvider>
            </Col>
            <Col className="filters__col-numeric">
                <Input
                    style={{ width: 210 }}
                    allowClear
                    placeholder={t('SEARCH_BY_NUMERIC_ID')}
                    prefix={<BsHash className="home__input-icon" />}
                    onChange={handleNumericId}
                    value={numericId}
                    disabled={loading}
                    maxLength={9}
                />
            </Col>
            {extra && (
                <Col flex="auto" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    {extra}
                </Col>
            )}
        </Row>
    );
};

export default Filters;
